import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as Chevron } from 'assets/images/chevron.svg';
import { ReactComponent as UserCheck } from 'assets/images/user-check.svg';

export const Header = styled.div`
  display: flex;
  padding: 24px;
`;

export const Title = styled.h4`
  font-size: 20px;
  line-height: 1.4;
  letter-spacing: -0.1px;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 16px;
`;

export const BackIcon = styled(Chevron)`
  color: ${ColorPalette.HEX.PineTree};
`;

export const UserCheckIcon = styled(UserCheck)`
  width: 21px;
  height: 23px;
  color: ${ColorPalette.HEX.RedRYB};
`;

export const SuccessContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`;
